import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatIconModule } from '@angular/material/icon';
import { NgIf } from '@angular/common';

import { LegalConsentModel } from '../../../../core/models/view-models/account-models/legal-consent.model';
import { AppConstants } from '../../../../app.constants';

@Component({
  selector: 'modal-legal-consent',
  templateUrl: './modal-legal-consent.component.html',
  styleUrls: ['./modal-legal-consent.component.scss'],
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatInputModule,
    MatTooltipModule,
    MatIconModule,
    FormsModule,
    NgIf
  ]
})
export class ModalLegalConsentComponent {
  legalConsent: LegalConsentModel;
  isEditing: boolean;
  appConst = AppConstants;
}
